import * as svg4everybody from 'svg4everybody';
import { platformBrowserDynamic } from 'ng-metadata/platform-browser-dynamic';
import { enableProdMode } from 'ng-metadata/core';
import { PortalModule } from './portal.module';

// Process env variable (available from Webpack)
if (process.env.MIX_ENV === 'prod') {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(PortalModule);

if (svg4everybody) {
  svg4everybody();
}



// WEBPACK FOOTER //
// ./resources/assets/js/main.ts